//import * as fc from "../global/fce.js";
import { Youtube } from "../class/Youtube.js";
import { HodnoceniObchodu } from "../class/HodnoceniObchodu.js";
import { Translation as Tr } from "../class/Translation.js";

//import Swiper from "swiper/swiper-bundle.mjs";

//import Swiper from "swiper/bundle";
//import "swiper/css/bundle";
import Swiper from "swiper";
import { Navigation, Scrollbar } from "swiper/modules";
// import Swiper styles
//import "swiper/swiper.css";
//import "swiper/css";

import { Top } from "../class/Top.js";
//import { Top } from "../class/Top.js";

function ldzSwiperMobile(nastaveni) {
  Lc.f("ldzSwiperMobile");
  Lc.log("Top.isMobil", Top.isMobil());
  if (!Top.isMobil()) {
    return false;
  }

  let vychozi = {
    obal: "",
    polozka: "",
    trida: "ldzMobileSwiper",
    spaceBetween: 16,
    slidesPerView: 1.25,
  };

  let S = $.extend({}, vychozi, nastaveni);

  $(S.obal).each(function(index) {
    let $wrapper = $(this);

    // ochrana proti dvojímu spuštění
    if ($wrapper.hasClass("ldz-swiper-hotovo")) {
      return;
    }

    let tridaSwiper = `${S.trida}-${index}`;
    let tridaOvladani = `${S.trida}-ctrl-${index}`;

    let $obal = $(`
      <div class="ldzSwiperObal">
        <div class="swiper ${S.trida} ${tridaSwiper}"></div>
      </div>
    `);

    // nový obal vložíme před původní products div
    $wrapper.before($obal);

    // původní products div se stane swiper-wrapper
    $wrapper.addClass("swiper-wrapper ldz-swiper-hotovo");

    // produkty se stanou slides
    $wrapper.find(`> ${S.polozka}`).addClass("swiper-slide");

    // původní products div přesuneme dovnitř .swiper
    $obal.find(".swiper").append($wrapper);

    let ovladani = `
      <div class="controls">
        <div class="swiper-button-prev ${tridaOvladani}"></div>
        <div class="swiper-button-next ${tridaOvladani}"></div>
        <div class="swiper-scrollbar ${tridaOvladani}"></div>
      </div>
    `;

    $obal.append(ovladani);

    let swiperEl = $obal.find(`.${tridaSwiper}`)[0];

    new Swiper(swiperEl, {
      modules: [Navigation, Scrollbar],

      slidesPerView: S.slidesPerView,
      spaceBetween: S.spaceBetween,
      centeredSlides: false,
      grabCursor: true,
      autoHeight: true,

      breakpoints: {
        // malé mobily
        0: {
          slidesPerView: 1.25,
        },

        // větší mobily
        480: {
          slidesPerView: 1.25,
        },

        // tablet / větší šířka
        768: {
          slidesPerView: 2.25,
        },
      },

      scrollbar: {
        el: $obal.find(`.swiper-scrollbar.${tridaOvladani}`)[0],
        hide: false,
        draggable: true,
      },

      navigation: {
        nextEl: $obal.find(`.swiper-button-next.${tridaOvladani}`)[0],
        prevEl: $obal.find(`.swiper-button-prev.${tridaOvladani}`)[0],
      },
    });
  });
}
function uv_prodejna() {
  let kod = "";

  //uvod_prodejna_adresa
  //uvod_prodejna_domluvit
  //url_kontakt

  let C = window.kontakty;

  let opt = {
    tel: `<a href="tel:${C.tel_odkaz}">${C.tel}</a>`,
    email: `<a href="mailto:${C.email_prodejna}">${C.email_prodejna}</a>`,
    interpolation: {
      escapeValue: false,
    },
  };

  kod = `
  <div class="flx">
  <div class="leva">
    <h2>${Tr.l("uvod_prodejna_nadpis")}</h2>
    <p>${Tr.l("uvod_prodejna_text", opt)}</p>
    <address>
      <strong>${Tr.l("uvod_prodejna_adresa")}</strong><br>
      BB ARENA<br>
      Rösslera-Ořovského 710/9<br>
      199 00, Praha 9
    </address>
    <a class="aBtn" href="${Tr.l("url_kontakt")}">${Tr.l(
    "uvod_prodejna_domluvit",
  )}</a>
  </div><!-- class="leva"-->
  </div><!-- class="flx"-->`;

  return kod;

  /*var $kod = "";

  $kod +=
    '<div class="leva"> \
    <img src="' +
    $shoptetUpload +
    '/uvod/shop_fotka.jpg"> \
    </div><!-- class="leva"-->';

  $kod +=
    '<div class="prava"> \
    <h2>' +
    Tr.l("uvod_prodejna_h") +
    "</h2>" +
    Tr.l("uvod_prodejna_p") +
    '</div><!-- class="prava"-->';

  return $kod;
  */
} //function  uv_prodejna()

/*
function uv_carousel() {
  if (typeof window.carousel != "object" || !window.carousel.zobrazit)
    return false;

  // $('<div class="owl-carousel"></div>').insertAfter('header#header');

  var $div = '<div class="owl-carousel">';

  window.carousel.polozky.forEach(function(entry) {
    $div +=
      '<div class="item"><a href="' +
      entry.url +
      '"><img src="' +
      $shoptetUpload +
      window.carousel.cesta +
      entry.obr +
      '"></a></div>';
  });

  $div += "</div>";

  return $div;
} //function  uv_carousel()
*/

/*
function uv_bannery() {
  var $kod = "";
  if (!$(".homepage-box .body-banners").length) return false;

  $(".homepage-box .body-banners .banner-wrapper > a").each(function() {
    var $link = $(this).attr("href");
    var $nazev = $(this)
      .find("span.extended-banner-title")
      .text()
      .trim();
    var $src = $(this)
      .find("img")
      .attr("data-src");
    var $textOdkazu = $(this)
      .find(".extended-banner-link")
      .text()
      .trim();
    if (!$textOdkazu.length) $textOdkazu = "více";

    $kod +=
      '<div class="dv">   \
           <a class="obr" href="' +
      $link +
      '"><img src="' +
      $src +
      '">  \
           <h3>' +
      $nazev +
      '</h3>    \
           </a> \
           <a class="link" href="' +
      $link +
      '">' +
      $textOdkazu +
      '</a> \
          </div><!-- class="dv"-->';
  });

  return $kod;
} //function  uv_bannery()

*/

function uv_JirkaBeran() {
  Lc.f("uv_JirkaBeran");

  var kod = "";

  kod += el("h2", Tr.l("uvod_intro_nadpis"));
  kod += el("p", Tr.l("uvod_intro_text"));

  kod += `
  <nav class="hero-categories" aria-label="Hlavní kategorie šermu">
    <a href="${Tr.l("url_sportovni_serm")}" class="aBtn sport">
      ${Tr.l("sportovni_serm")}
    </a>

    <a href="${Tr.l("url_historicky_serm")}" class="aBtn historical">
      ${Tr.l("historicky_serm_hema")}
    </a>
  </nav>
  <div class="dvStars"></div>`;

  return kod;
} //function  uv_JirkaBeran()

function uv_vyhody() {
  Lc.f("uv_vyhody");

  let kod = `
  <section id="secUvodVyhody" class="vyhody" aria-labelledby="vyhody-nadpis">
	<div class="cntmax">	
		<ul>
			<li class="vyhoda dorucime">
        ${Tr.l("uvod_vyhoda_dorucime")}
			</li>
			<li class="vyhoda sermiri">
        ${Tr.l("uvod_vyhoda_overeno_sermiri", { score: "4,9" })}			
			</li>
			<li class="vyhoda showroom">
        ${Tr.l("uvod_vyhoda_showroom")}					
			</li>

			<li class="vyhoda youtube">
        ${Tr.l("uvod_vyhoda_youtube")}
			</li>
		</ul>
	</div>
</section>
  
  `;

  return kod;
}

function uv_swiperProduktyMobil() {
  ldzSwiperMobile({
    obal: "#products-1",
    polozka: ".product",
    trida: "ldzProduktySwiper",
    slidesPerView: 2.25,
    spaceBetween: 16,
  });
}

function uv_swiperProduktyVybalenoMobil() {
  ldzSwiperMobile({
    obal: "#products-2",
    polozka: ".product",
    trida: "ldzProduktySwiper",
    slidesPerView: 2.25,
    spaceBetween: 16,
  });
}

export function upravUvodniStranku() {
  Lc.f(" upravUvodniStranku");

  var kod = `<div id="dvAll"></div>`;

  $("#header").after(kod);

  //--jiri beran doporucuje
  var $fceBeran = uv_JirkaBeran();

  if ($fceBeran.length) {
    $(
      '<div id="dvJB"><div class="cntmax"><div class="cnt">' +
        $fceBeran +
        '</div></div></div><!--id="dvJB" -->',
    ).appendTo("#dvAll");
  }

  $(".wide-carousel").each(function() {
    $(this).wrap('<div id="dvCarousel"><div class="cntmax"></div></div>');
    //$(this).wrap('<div id="dvCarousel"></div>');
    /*
    $(this)
      .parent()
      .appendTo("#dvAll");*/

    $("#dvCarousel").appendTo("#dvAll");
  });

  var $kod = "";

  //vyhody-boxy
  $kod = uv_vyhody();
  if ($kod.length) {
    Lc.log('vlozeniii "vyhody"');
    $("#dvCarousel").after($kod);
    //$("#dvAll").append($kod);
  }

  //---doporucujeme
  $("#products-1").each(function() {
    var $h4 = $(this).prev(".h4");
    $(this).wrap('<div id="dvDop" class="container homeBox"></div>');
    var $rodic = $(this).parent();
    $h4.prependTo($rodic);
    //$h4.text(Tr.l("uvod_jirka_beran_doporucuje_h4"));
    //$rodic.insertAfter('#content-wrapper');
    $rodic.appendTo("#dvAll");
    //$rodic.insertAfter($fceBeran.length ? "#dvJB" : "#content-wrapper");

    //TODO:  upravit if Top.isMobil() tak swiper
    if (Top.isMobil()) {
      uv_swiperProduktyMobil();
    }
  });

  //url_historicky_serm
  /**
   *
   * @returns ${Tr.l("url_login")}
   */

  Lc.log("Tr", window.LdzTr);

  //prodejna
  var $fce = uv_prodejna();
  $kod = "";
  if ($fce.length) {
    $kod +=
      '<div id="dvProdej"><div class="cntmax"><div class="cnt">' +
      $fce +
      '</div></div></div><!--id="dvProdej" -->';

    $($kod).insertAfter("#dvDop");
  }

  //$("#products-6,#products-2")
  $("#products-2").each(function() {
    var $h4 = $(this).prev(".h4");
    $(this).wrap('<div id="dvNov" class="container homeBox"></div>');
    var $rodic = $(this).parent();
    $h4.prependTo($rodic);
    //$h4.text(Tr.l("uvod_pr_h_novinky"));
    $rodic.insertAfter("#dvProdej");

    if (Top.isMobil()) {
      uv_swiperProduktyVybalenoMobil();
    }
  });

  $kod = "";

  $kod +=
    '<div id="dvHodnoceni"><div class="cntmax"></div></div><!--id="dvCarouObsah" -->';
  //$kod += '<div id="dvAkt"></div><!--id="dvAkt" -->';

  if ($kod) $($kod).insertAfter("#dvNov");

  // var $fceVidea = false;
  Youtube.getVideosFromPlaylist({
    playlistID: "PLyHJCoNDCsI1yNjBUps-sNoFps6Vw_rTv",
    apiKey: "AIzaSyAF9n2fBWrpklSEsiDtexUhy7pXNXcy96I",
    max: 4,
    //titleMax: 32,
    titleMax: 75,
    title: true,
  }).then((kod) => {
    let $h2 = el("h2", Tr.l("uvod_ytb_h"));
    $(
      '<div id="dvVid"><div class="cntmax">' +
        $h2 +
        '<div class="cnt">' +
        kod +
        '</div></div></div><!--id="dvJB" -->',
    ).insertAfter("#dvHodnoceni");
    Youtube.showYoutubeVideos();
    //$fceVidea = "ok";
  });

  let odkazHodnoceni = `<a class="aVsechnyR" href="${Tr.l(
    "url_hodnoceni_obchodu",
  )}" >${Tr.l("hodnoceni_vsechny_recenze")}</a>`;
  //--HodnoceniObchodu
  HodnoceniObchodu.ziskejHodnoceni({
    max: 3,
  }).then((data) => {
    if (!data) {
      return;
    }

    Lc.log("HodnoceniObchodu data", data);

    let pocetText = Tr.l("uvod_intro_hodnoceni", {
      hodnoceni: data.pocet,
    });

    // Score do výhody "ověřeno šermíři".
    $("#secUvodVyhody .vyhoda.sermiri").html(
      Tr.l("uvod_vyhoda_overeno_sermiri", {
        score: data.score,
      }),
    );
    // Score nahoru.
    $("#dvJB .dvStars").html(
      '<div class="shop-score">' +
        '<span class="score">' +
        data.score +
        "</span>" +
        '<span class="shop-score-right">' +
        data.hvezdy +
        '<span class="pocet">' +
        pocetText +
        "</span>" +
        "</span>" +
        "</div>",
    );

    // Hodnocení dolů.
    let $h2 = el("h2", Tr.l("uvod_h_hodnoceni_obchodu"));

    $(
      '<div id="dvH"><div class="cntmax">' +
        $h2 +
        '<div class="hodnoceni">' +
        data.kod +
        "</div>" +
        odkazHodnoceni +
        "</div></div>",
    ).appendTo("#dvHodnoceni .cntmax");
  });
  /*
  HodnoceniObchodu.ziskejHodnoceni({
    max: 3,
  }).then((kod) => {
    let $h2 = el("h2", Tr.l("uvod_h_hodnoceni_obchodu"));
    $(
      '<div id="dvH"><div class="cntmax">' +
        $h2 +
        '<div class="hodnoceni">' +
        kod +
        '</div></div></div><!--id="dvJB" -->',
    ).appendTo("#dvHodnoceni .cntmax");
  });
  */

  //uv_aktuality();
} //export function  upravUvodniStranku()
